// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Directive, OnInit, OnDestroy, ElementRef, Inject, Input } from '@angular/core';
import { ThemeService } from '../theme/theme.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { Theme } from '../theme/themes';

@Directive({
    selector: '[tenant-theme]',
})
export class ThemeDirective implements OnInit, OnDestroy {
    @Input() scoped = false;
    private _destroy$ = new Subject();

    constructor(
        private _elementRef: ElementRef,
        private _themeService: ThemeService,
        @Inject(DOCUMENT) private _document: any
    ) {}

    ngOnInit() {
        const active = this._themeService.getActiveTheme();

        if (active) {
            this.updateTheme(active);
        }

        this._themeService.themeChange.pipe(takeUntil(this._destroy$)).subscribe((theme: Theme) => this.updateTheme(theme));
    }

    ngOnDestroy() {
        this._destroy$.next(null);
        this._destroy$.complete();
    }

    updateTheme(theme: Theme) {
        // element is the div that contains the main router-outlet on app.componnet.html
        // this applies the styles to all child components
        const element = this.getElement();

        // add props to the element
        for (const key in theme.properties) {
            element.style.setProperty(key, theme.properties[key]);
        }

        // remove old theme
        if (this._themeService.theme) {
            for (const name of this._themeService.theme) {
                element.classList.remove(`${name}-theme`);
            }
        }

        // alias element with theme name
        element.classList.add(`${theme.name}-theme`);
    }

    getElement() {
        return this.scoped ? this._elementRef.nativeElement : this._document.body;
    }
}
